module.exports = __webpack_public_path__ + "static/img/applemusic.7eaaee9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content/applemusic.svg
// module id = FckN
// module chunks = 1